export default __webpack_public_path__ + "f71e9fb.png";